// removed by extract-text-webpack-plugin
module.exports = {"Person":"Person__Person__17ToL"};


//////////////////
// WEBPACK FOOTER
// ./src/Person/Person.css
// module id = 20
// module chunks = 0